var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"id":"dt_program"}},[_c('HistoryImportTable',{attrs:{"loading":_vm.table_loading,"data":_vm.data},on:{"refresh-list":_vm.fetch,"sorting":_vm.sorting,"downloadFile":_vm.download}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }